export default __webpack_public_path__ + "static/media/8924.db169ecb.svg";